import { SxProps, Theme } from '@mui/material';
import { CrmColors } from '../../crm-theme';
import { CONTROL_HEIGHT } from './crm-board-bar.styles';

/// `active`: algum filtro do popover está ligado.
export const filtersButtonSx = (cc: CrmColors, active: boolean): SxProps<Theme> => ({
    height: CONTROL_HEIGHT,
    bgcolor: active ? cc.accentSoftBg : cc.surfaceBg,
    border: `1px solid ${active ? cc.accent : cc.border}`,
    borderRadius: '9px',
    color: active ? cc.accent : cc.textPrimary,
    textTransform: 'none',
    fontSize: '13px',
    '&:hover': { bgcolor: cc.countBg, border: `1px solid ${cc.borderStrong}` },
});

export const filtersPopoverSx = (cc: CrmColors): SxProps<Theme> => ({
    mt: 1,
    p: 2,
    width: 300,
    bgcolor: cc.menuBg,
    backgroundImage: 'none',
});
